export default __webpack_public_path__ + "static/media/monocarton-section.3625736d.png";